var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_779_16621",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_779_16621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.375 5.4V14.025C15.375 14.4 15.2438 14.7188 14.9813 14.9813C14.7188 15.2438 14.4 15.375 14.025 15.375H3.975C3.6 15.375 3.28125 15.2438 3.01875 14.9813C2.75625 14.7188 2.625 14.4 2.625 14.025V3.975C2.625 3.6 2.75625 3.28125 3.01875 3.01875C3.28125 2.75625 3.6 2.625 3.975 2.625H12.6L15.375 5.4ZM14.25 5.8875L12.1125 3.75H3.975C3.9125 3.75 3.8595 3.772 3.816 3.816C3.772 3.8595 3.75 3.9125 3.75 3.975V14.025C3.75 14.0875 3.772 14.1407 3.816 14.1847C3.8595 14.2283 3.9125 14.25 3.975 14.25H14.025C14.0875 14.25 14.1407 14.2283 14.1847 14.1847C14.2283 14.1407 14.25 14.0875 14.25 14.025V5.8875ZM9 12.9562C9.525 12.9562 9.96875 12.7718 10.3312 12.4028C10.6937 12.0343 10.875 11.5938 10.875 11.0812C10.875 10.5562 10.6937 10.1125 10.3312 9.75C9.96875 9.3875 9.525 9.20625 9 9.20625C8.475 9.20625 8.03125 9.3875 7.66875 9.75C7.30625 10.1125 7.125 10.5562 7.125 11.0812C7.125 11.5938 7.30625 12.0343 7.66875 12.4028C8.03125 12.7718 8.475 12.9562 9 12.9562ZM4.78125 7.40625H10.95V4.78125H4.78125V7.40625Z",
    fill: "#0A5DFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.759b505b8d18a838bb9c6df36e66f8aa.svg";
export { ForwardRef as ReactComponent };